import classnames from 'classnames'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import RefiMessages from '../InterestSection/RefiByYearsInHome/RefiMessages'
import RefiOptionCard from './RefiOptionCard'
import { Button } from '@homebot/shared-ui-swashbuckle'
import Block from './Block'
import Header from './Header'
import { ARM_MORTGAGE_TYPE } from '../../../constants/loan'

import styles from './RefiOption.module.scss'

const propTypes = {
  detail: PropTypes.shape({
    type: PropTypes.oneOf(['FIX', 'ARM']),
    years: PropTypes.number,
    rate: PropTypes.number,
    apr: PropTypes.number,
    longterm: PropTypes.number,
    shortterm: PropTypes.number,
  }).isRequired,
  yearsInHome: PropTypes.number,
  onClick: PropTypes.func,
  locked: PropTypes.bool,
}

const RefiOption = ({ detail, yearsInHome, onClick, locked, ...restProps }) => {
  const pmiPayment = useSelector(state => state.pmi.monthlyPmiPayment)

  const handleClick = e => {
    e.stopPropagation()
    onClick(e)
  }

  return (
    <RefiOptionCard
      className={styles.card}
      data-qa={`RefiOption-Details-${
        detail.years
      }-${detail.type.toLowerCase()}-horizontal`}
      onClick={locked ? () => null : handleClick}
      {...restProps}
    >
      <Header
        className={classnames(
          styles.header,
          detail.longterm < 0 && styles.headerNudge
        )}
        type={detail.type}
        years={detail.years}
        rate={detail.rate}
        apr={detail.apr}
        longterm={detail.longterm}
        caution={
          detail.type === ARM_MORTGAGE_TYPE && yearsInHome > detail.years
        }
        locked={locked}
      />
      <Block className={styles.body}>
        <RefiMessages.ShortBullets
          yearsInHome={yearsInHome}
          locked={locked}
          pmi={pmiPayment}
          {...detail}
        />
      </Block>
      <Button
        size='sm'
        variant='ghost'
        colorScheme='btn-primary'
        data-qa='refi-more-details-button'
        onClick={!locked && handleClick}
      >
        <FormattedMessage
          id='RefiOption.button.whatRate.narrow'
          defaultMessage='What’s your rate?'
        />
      </Button>
    </RefiOptionCard>
  )
}

RefiOption.propTypes = propTypes

export default RefiOption
